import IAudit from "../responses/IAudit";
import Site from "./Site";
import { OrderHeadStatus } from "../Enums";
import OrderLine from "./OrderLine";
import Supplier from "./Supplier";

export default class Order {
  constructor(
    public id: number,
    public site: Site,
    public code: string,
    public status: OrderHeadStatus,
    public completeReason: string | undefined,
    public supplier: Supplier,
    public lines: OrderLine[],
    public audit: IAudit,
    public exposedOrderToken: string,
    public deliveryDate: Date | undefined,
  ) { }
  
  public get isPartialDelivery(): boolean {
    return this.completeReason === 'partial';
  }

  public get isPartialDeliveryAny(): boolean {
    if (!this.completeReason) return false;
    return this.completeReason === 'partial' || this.completeReason.startsWith('partial-');
  }
 
  public get hasUnderDelivery(): boolean {
    return this.lines.some((line) => line.deliveredQuantity && line.quantity > line.deliveredQuantity);
  }
}
